import { Lift } from "@/components/common/Motion";

export function KpiCard({ label, value, hint, tone = "default", testid }) {
  const toneRing = tone === "positive" ? "ring-[#16A46B]/25" : tone === "warn" ? "ring-[#E3252A]/25" : "ring-[#E4E9EF]";
  return (
    <Lift
      data-testid={testid || "kpi-card"}
      className={`rounded-xl bg-white p-5 ring-1 ${toneRing} hs-card-shadow`}
    >
      <div className="text-xs font-semibold uppercase tracking-wider text-[#8A97A0]">{label}</div>
      {/* tabular-nums so a figure updating in place does not shift the ones
          beside it as digit widths change. */}
      <div className="mt-2 font-display text-2xl font-bold tabular-nums text-[#0B2B33]">{value}</div>
      {hint ? <div className="mt-1 text-xs text-[#43535E]">{hint}</div> : null}
    </Lift>
  );
}
